// React
import React, { Component } from "react";
import { Helmet } from 'react-helmet';

// Libraries
import Moment from 'moment';
import Scrollbar from 'react-smooth-scrollbar';

// Panel
import { PanelHeading, PanelBody } from '../../Components';
import { ClientRoutes } from '../../Routes';
import { Tweet } from './';

const io = require('socket.io-client');

class Peak extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            message : {
                title : 'Loading News',
                details : 'All of the latest news coming hot off the press.',
                type : 'warning'
            },
            stackSize: 5,
            topics: ['BTC', 'ETH', 'XRP'],
            tweets : []
        };

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        console.log('Peak.componentDidMount()');

        const socket = io.connect('localhost:2002', {forceNew:true, autoConnect: true});

        this.state.topics.map( (topic) => {
            socket.on(topic, (tweet) => {
                
                this.saveTweet(tweet);
            });
        });

    }

    // After component update, check to see if news needs refresh
    componentDidUpdate(prevProps, prevState) {


    }

/**********************************************************
 *  Helper Functions
 **********************************************************/
    saveTweet = (tweet) => {

        var oldTweets = Array.from(this.state.tweets);

        if(oldTweets.length < 5) {

            oldTweets.unshift(tweet);

            this.setState((prev, props) => {
                return {
                    tweets : oldTweets//[tweet, ...prev.tweets]
                }
            });
        }

        /*if(oldTweets.length >= this.state.stackSize) {
            oldTweets.pop();
            oldTweets.unshift(tweet);
        }
        else
            oldTweets.unshift(tweet); 

        this.setState((prev, props) => {
            return {
                tweets : oldTweets//[tweet, ...prev.tweets]
            }
        });*/
    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    const peakHeight = window.innerHeight - 170;

    return (

        <div className="page-container">

            <Helmet>
                <meta charSet="utf-8" />
                <title>Yety | Peak - Cryptocurrency Trading and Analytics Platform - The Most Advanced Cryptocurrency Analytics Ever Made</title>
                <link rel="canonical" href="https://yety.io/peak" />
                <meta name="keywords" content="cryptocurrency, trading, analytics, pnl, profit, loss, holdings, assets, margin, positions, orders, kraken, poloniex, BTC, ETH, LTC, XRP, DASH, BCH EUR, USD, CAD"/>
                <meta name="description" content="Yety Peak has real-time machine learning and sentiment analysis on news articles, tweets and even reddit posts." />

                <meta property="og:url" content="https://yety.io/peak" />
                <meta property="og:title" content="Yety | Peak - Cryptocurrency Trading and Analytics Platform" />
                <meta property="fb:app_id" content="378120756002310" />
                <meta property="twitter:title" content="Yety | Peak - Cryptocurrency Trading and Analytics Platform" />
            </Helmet>

          <div className="page-content">

            <div className="content-wrapper">

              {/*-----------  Page header -----------*/}

              {/*-----------  Content Area -----------*/}
              <div className="content">

                {/*-----------  Top Row  -----------*/}
                <div className="row row-sortable ui-sortable">
                    
                    {/*-----------  Present Column -----------*/}
                    <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">

                        <div className="panel panel-flat bg-theme-700">
                            <PanelHeading title={"Tweets"} description='live tweets' sample={this.props.user === null ? true : false} refresh={null}>
                            </PanelHeading>
                            <Scrollbar damping={0.1} thumbMinSize={20} continuousScrolling={true} renderByPixels={false} alwaysShowTracks={false}>
                            <div style={{ height: peakHeight, paddingTop: 0, overflowY: 'visible' }}>
                                <PanelBody message={null} >
                                {
                                    this.state.tweets.map( (tweet) => {
                                        return (
                                            <Tweet key={tweet.id_str} tweet={tweet} />
                                        );
                                    })
                                }
                                </PanelBody>
                            </div>
                            </Scrollbar>
                        </div>
                    </div>
                    {/*-----------  /Present Column -----------*/}

                    {/*-----------  Future Column -----------*/}
                    <div className="col-lg-5 col-md-6 col-sm-6 col-xs-12">
                    
                     
                    </div>
                    {/*-----------  /Future Column -----------*/}


                    {/*-----------  Past Column -----------*/}
                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">

                    </div>
                    {/*-----------  /Past Column -----------*/}


                </div>
                {/*-----------  /Grid -----------*/}

              </div>
              {/*-----------  /Content Area -----------*/}


            </div>

          </div>
        </div>
    );
  }

}

export default Peak;





// WEBPACK FOOTER //
// ./src/Views/Peak/Peak.js